export default {
	methods: {
		/**
		 * This function needs that this.tasks is loaded
		 * @param {string} year Last two digit of the year
		 * @param {number} month
		 * @param {number} contract_id
		 * @returns {Object} tasks: List of tasks, done: number of task done (== 1)
		 */
		getMonthTasks(year, month, contract_id, thisTasks){
			let monthTasks = thisTasks.filter(task => {
				if(task.creation_date){
					return task.creation_date.substr(0, 4) == year &&
						Number(task.creation_date.substr(5, 2)) == (month.length == 2 ? Number(month) : Number("0" + String(month))) &&
						task.archivate != 2 &&
						task.contract_id == contract_id;
				}
				else{
					return false;
				}
			});
			let monthTaskDone = monthTasks.filter(task => task.archivate == 1).length;
			return {tasks: monthTasks, done: monthTaskDone};
		},
	}
};